import { render, staticRenderFns } from "./detailRight.vue?vue&type=template&id=09def9e0&scoped=true"
import script from "./detailRight.vue?vue&type=script&lang=js"
export * from "./detailRight.vue?vue&type=script&lang=js"
import style0 from "./detailRight.vue?vue&type=style&index=0&id=09def9e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09def9e0",
  null
  
)

export default component.exports